<template>
    <div>
        <div class="searchInput">
            <Input v-model="searchValue" search enter-button placeholder="疾病名称、分类、关键字"
                @on-search="searchTemplate" />
        </div>
        <Collapse accordion @on-change="changeParts" v-model="collapseIndex" v-if="collapseShow">
            <Panel v-for="(i, index) in secondList" :key="index" :name="JSON.stringify(index)">
                <span style="font-size:16px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">{{ i }}</span>
                <div slot="content" v-for="template in templateList">
                    <Poptip
                        :class="[template.isNormal == 0 ? 'templatePopTipGood' : 'templatePopTipError', 'templatePopTip']"
                        :title="template.title" word-wrap width="350" trigger="hover" placement="left-start">
                        <div class="titlecontent" @click="checkTemplate(template)">{{ template.title }}</div>
                        <div class="content" style="padding:0;" slot="content">
                            <h3>影像学所见</h3>
                            <p>{{ template.description }}</p>
                            <h3>影像学提示</h3>
                            <p>{{ template.contents }}</p>
                        </div>
                    </Poptip>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>

<script>
export default {
    props: ["deviceType"],
    data() {
        return {
            searchValue: '',
            secondList: [],
            collapseIndex: "",
            classification: [],
            templateList: [],
            collapseShow: true
        }
    },
    methods: {
        _initData() {
            this.searchSecond()
        },
        searchSecond() {
            let data = {
                deviceType: this.deviceType,
                keywords: this.searchValue || ''
            }
            this.$api.data.findTemplateReportDiseaseType(data).then((res) => {
                this.secondList = res.list
                // 不展开
                this.collapseIndex = ""
            })
        },

        changeParts(collapseIndex) {
            if (collapseIndex.length > 0) {
                let data = {
                    deviceType: this.deviceType,
                    diseaseType: this.secondList[collapseIndex[0]],
                    keywords: this.searchValue || ''
                }
                this.$api.data.findTemplateReportSelf(data).then((res) => {
                    this.templateList = res.list
                })
            }
        },
        checkTemplate(value) {
            this.$emit('checkTemplate', value)
        },

        searchTemplate() {
            // 展开状态，只查询
            if (this.collapseIndex.length > 0) {
                this.changeParts(this.collapseIndex)
            } else {
                this.searchSecond()
            }
        }
    },
    watch: {
        deviceType(newval, oldval) {
            this.searchSecond()
        }
    },
    mounted() {
        this._initData()
    }
}
</script>

<style lang="scss" scoped>
.searchInput {
    margin-bottom: 10px;
}

.templatePopTipGood {
    border-left: 5px solid green;
    border-right: 5px solid green;

    &:hover {
        background: green;
        color: white;
    }
}

.templatePopTipError {
    border-left: 5px solid #ed4014;
    border-right: 5px solid #ed4014;

    &:hover {
        background: #ed4014;
        color: white;
    }
}

.templatePopTip {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 5px;
    border-bottom: 1px solid #dddddd;
    cursor: pointer;

    .content {
        color: black;
        // background: green;
    }

    .titlecontent {
        // width: 100%;
        width: 300px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/WriteHanding/PersonalTemplate.vue